(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["neu-im-sortiment"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const delay = Number(root.dataset.rotationDelay) || 6000;
      root.querySelectorAll('[data-new-arrivals-group]').forEach((group, groupIndex) => {
        const products = Array.from(group.querySelectorAll('[data-new-arrivals-product]'));
        if (products.length < 2) return;

        let currentIndex = 0;
        let intervalId;
        let isTransitioning = false;

        const showNext = () => {
          if (isTransitioning) return;
          isTransitioning = true;

          const currentProduct = products[currentIndex];
          const nextIndex = (currentIndex + 1) % products.length;
          const nextProduct = products[nextIndex];

          currentProduct.classList.add('is-leaving');

          window.setTimeout(() => {
            currentProduct.hidden = true;
            currentProduct.setAttribute('aria-hidden', 'true');
            currentProduct.classList.remove('is-leaving');

            nextProduct.classList.add('is-entering');
            nextProduct.hidden = false;
            nextProduct.setAttribute('aria-hidden', 'false');

            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                nextProduct.classList.remove('is-entering');
                currentIndex = nextIndex;
                window.setTimeout(() => {
                  isTransitioning = false;
                }, 520);
              });
            });
          }, 520);
        };

        const start = () => {
          window.clearInterval(intervalId);
          intervalId = window.setInterval(showNext, delay);
        };

        const stop = () => window.clearInterval(intervalId);
        window.setTimeout(start, groupIndex * 900);
        group.addEventListener('mouseenter', stop);
        group.addEventListener('mouseleave', start);
        group.addEventListener('focusin', stop);
        group.addEventListener('focusout', start);
      });
    };

    document.querySelectorAll('[data-new-arrivals]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-new-arrivals]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
